import React from 'react';
import { FormViewContent } from 'components/FormViewContent';
import atoms from 'ctsutheme/components/atoms';
import PropTypes from 'prop-types';
import { GetEmptyValue } from 'components';

const { Divider } = atoms;

const ViewStatusChange = ({ statusChangeInfo }) => (
  <>
    <FormViewContent
      primaryText="Requested Status"
      name="rqtGrpProtStatus"
      secondaryText={(
        <GetEmptyValue
          value={statusChangeInfo && statusChangeInfo.rqtGrpProtStatus}
        />
)}
    />
    <Divider />
    <FormViewContent
      primaryText="Requested Status Date (ET)"
      name="rqtGrpProtStatusDate"
      secondaryText={(
        <GetEmptyValue
          value={statusChangeInfo && statusChangeInfo.rqtGrpProtStatusDate}
        />
)}
    />
    <Divider />

    <FormViewContent
      primaryText="Rationale"
      name="rationale"
      secondaryText={(
        <GetEmptyValue
          value={statusChangeInfo && statusChangeInfo.rationale}
        />
)}
    />
    <Divider />

    <FormViewContent
      primaryText="Reason"
      name="statusReason"
      secondaryText={(
        <GetEmptyValue
          value={statusChangeInfo && statusChangeInfo.statusReason}
        />
)}
    />
    <Divider />

    <FormViewContent
      primaryText="Other Specify"
      name="otherSpecify"
      secondaryText={(
        <GetEmptyValue
          value={statusChangeInfo && statusChangeInfo.otherSpecify}
        />
)}
    />
    <Divider />

    <FormViewContent
      primaryText="PIO comments"
      name="pioRequestComments"
      secondaryText={(
        <GetEmptyValue
          value={statusChangeInfo && statusChangeInfo.pioRequestComments}
        />
)}
    />
  </>
);

ViewStatusChange.propTypes = {
  statusChangeInfo: PropTypes.oneOfType([PropTypes.object])
};

ViewStatusChange.defaultProps = {
  statusChangeInfo: null
};

export default ViewStatusChange;
